/*
 Copyright 2026 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the
 project root for license information.
*/

/**
 * Blueprint API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MselRole = {
    Owner: 'Owner',
    Editor: 'Editor',
    Approver: 'Approver',
    MoveEditor: 'MoveEditor',
    Viewer: 'Viewer',
    Evaluator: 'Evaluator'
} as const;
export type MselRole = typeof MselRole[keyof typeof MselRole];

